import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://freedisposableemail.com';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website',
  noindex = false,
  structuredData = null
}) => {
  const location = useLocation();
  const canonicalUrl = `${BASE_URL}${location.pathname}`;

  useEffect(() => {
    // Update document title
    document.title = title || 'FreeDisposableEmail.com - Free Temporary Email Service';

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description || 'Free temporary email service. Get instant disposable email addresses with no registration required. Protect your privacy online.');
    updateMetaTag('keywords', keywords || 'temporary email, disposable email, temp mail, throwaway email, fake email, free email, email privacy, spam protection');
    updateMetaTag('author', 'FreeDisposableEmail.com');
    updateMetaTag('robots', noindex ? 'noindex, nofollow' : 'index, follow');
    updateMetaTag('viewport', 'width=device-width, initial-scale=1.0, maximum-scale=5.0');
    updateMetaTag('theme-color', '#3b82f6');

    // Open Graph tags
    updateMetaTag('og:title', title || 'FreeDisposableEmail.com - Free Temporary Email Service', true);
    updateMetaTag('og:description', description || 'Free temporary email service. Get instant disposable email addresses with no registration required.', true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:image', image || `${BASE_URL}/assets/img/logo/freedisposibleemail-logo.png`, true);
    updateMetaTag('og:site_name', 'FreeDisposableEmail.com', true);
    updateMetaTag('og:locale', 'en_US', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title || 'FreeDisposableEmail.com - Free Temporary Email Service');
    updateMetaTag('twitter:description', description || 'Free temporary email service. Get instant disposable email addresses with no registration required.');
    updateMetaTag('twitter:image', image || `${BASE_URL}/assets/img/logo/freedisposibleemail-logo.png`);

    // Canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // Language
    document.documentElement.setAttribute('lang', 'en');

    // Structured Data (JSON-LD)
    if (structuredData) {
      let scriptTag = document.querySelector('script[type="application/ld+json"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(structuredData);
    }
  }, [title, description, keywords, image, type, noindex, canonicalUrl, structuredData]);

  return null;
};

export default SEO;
